export default __webpack_public_path__ + "static/media/favicon.ca823bb6.ico";